import { useQuery } from "@tanstack/react-query";
import { useMatch } from "@tanstack/react-router";

import type { ArtistDirectorySearchState } from "@/features/feature-page/artist-directory-query";
import { getFeaturePageQueryOptions } from "@/features/feature-page/feature-page-query";
import { FeaturePageStructuredData } from "@/features/feature-page/feature-page-structured-data";
import type { FeaturePageFamily } from "@garimpa/lib/featurePage";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

/** Keeps query-driven editorial data scripts at the document body's end. */
export function FeaturePageDocumentStructuredData() {
  const published = useMatch({ from: "/_app/$lang/$family/$slug/", shouldThrow: false });
  const draft = useMatch({ from: "/_app/$lang/$family/$slug/draft", shouldThrow: false });

  if (published?.loaderData) {
    const { family, locale, slug } = published.loaderData;
    return (
      <PublishedFeaturePageStructuredData
        family={family}
        locale={locale}
        slug={slug}
        search={published.search}
      />
    );
  }
  if (draft?.loaderData) {
    return <FeaturePageStructuredData page={draft.loaderData.page} search={draft.search} />;
  }
  return null;
}

function PublishedFeaturePageStructuredData({
  family,
  locale,
  slug,
  search,
}: {
  family: FeaturePageFamily;
  locale: ViewerLocale;
  slug: string;
  search: ArtistDirectorySearchState;
}) {
  const { data: page } = useQuery(getFeaturePageQueryOptions({ family, locale, slug }));
  return page ? <FeaturePageStructuredData page={page} search={search} /> : null;
}
